<template>
	<div class="checkout-price annual-sales">
		<div class="annual-sales__checkout">
			<div class="checkout__items">
				<covid-19>
					<template v-slot:current>
						<div class="checkout-price__bell">
							<button class="checkout-price__button btn checkout__item" @click="$emit('checkout', 'bottom')">
								CHECKOUT
							</button>
						</div>
					</template>
					<template v-slot:covid>
						<p class="suspended">Checkout suspended</p>
						<button @click="$emit('show-contingency-modal')" class="checkout-price__button btn checkout__item">
							Notify Me
						</button>
					</template>
				</covid-19>
			</div>
			<promo-sales-timed>
				<template v-slot:originalContent>
					<div class="checkout-price__amount-container">
						<h2 class="checkout-price__amount">
							{{ buildPrice | formatMoney }}
						</h2>
						<span class="currency-code">USD</span>
					</div>
				</template>
				<template>
					<div class="checkout-price__amount-container">
						<h2 class="checkout-price__amount">
							${{ discountPrice }}
						</h2>
						<span class="holiday-price">{{ buildPrice | formatMoney }}</span>
					</div>
				</template>
			</promo-sales-timed>
		</div>
		<promo-sales-timed>
			<template slot-scope="{ phasesInfo: { currentPhase } }">
				<holiday-savings-msg
					v-if="applyCase"
					:phase="currentPhase"
					text="configurator"
				/>
				<holiday-savings-msg
					v-else
					:phase="currentPhase"
					text="configurator2"
				/>
			</template>
		</promo-sales-timed>
	</div>
</template>

<script>
import _isEmpty from "lodash/isEmpty";
import Covid19 from "@c/covid-19";
import PromoSalesTimed from "@/components/promo-sales-timed";
import HolidaySavingsMsg from "@c/generals/holiday-saving-msg";
import { casePromo, promoDiscount } from "@u/helpers";



export default {
	name: "CheckoutPrice",
	components: {
		Covid19,
		PromoSalesTimed,
		HolidaySavingsMsg
	},
	props: {
		buildPrice: {
			type: [Number, String],
			required: true
		},
		buildCase: {
			type: [Object, Array],
			default() {
				return {};
			}
		}
	},
	computed: {
		buildHasElegiblePrice() {
			return !Number.isNaN(Number(this.buildPrice)) && Number(this.buildPrice) >= 1000;
		},
		discountPrice() {
			return promoDiscount(this.buildPrice);
		},
		applyCase() {
			if (_isEmpty(this.buildCase)) {
				return false;
			}

			return casePromo(this.buildCase);
		}
	},
	mounted() {
		const suspended = document.querySelectorAll(".suspended");

		if (suspended.length) {
			suspended[0].style.display = "none";
		}
	}
};
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.holiday-price {
	font-size: 16px;
	color: $white;
	font-weight: 200;
	text-decoration: line-through;
	margin-left: 3px;
	margin-right: 3px;
}

.currency-code {
	font-size: 14px;
	font-weight: 200;
	color: rgba($color: #fafafa, $alpha: .6);
	margin-bottom: -10px;
	position: relative;
	margin-left: 2px;

	@media (min-width: 320px) and (max-width: 480px) {
		margin-right: 10px;
	}
}

@media (min-width: 320px) and (max-width: 480px) {
	.checkout-price__amount {
		font-size: 25px;
	}

	.currency-code {
		margin-right: 10px;
	}
}

.checkout-price {
	display: flex;
	align-items: center;
	justify-content: flex-end;

	@media (max-width: 767px) {
		flex-direction: row-reverse;
	}

	&__button {
		font-family: "Akkurat-Light";
		font-size: 14px;
		letter-spacing: 1px;
		text-align: center;
		border-radius: 0;
		padding: 10px 16px;
		border: 0;
		background-color: $orchid;
		color: $white;
		margin-right: 10px;

		@media (max-width: 767px) {
			height: 55px;
			width: 145px;
			margin-right: 0;
		}

		&:hover {
			background-color: $white;
			color: $black;
		}
	}

	&__amount-container {
		display: flex;
		align-items: baseline;
	}

	&__amount {
		font-size: 36px;
		color: $white;
		margin: 0;

		@media (min-width: 320px) and (max-width: 480px) {
			font-size: 30px
		}

		@media (max-width: 767px) {
			font-family: Akkurat-Light;
		}
	}
}

.checkout-price-bottom {
	.checkout-price {
		@media (max-width: 767px) {
			padding: 17.5px 0;
		}
	}
}

.checkout-price-bottom {
	.checkout-price {
		@media (min-width: 768px) {
			flex-direction: column;
			align-items: flex-end;

			.checkout-price__amount {
				margin-bottom: 10px;
				order: 0;
			}

			.checkout__items {
				order: 1;
				text-align: right;
			}
		}
	}
}

.annual-sales {
	&__checkout {
		display: contents;
	}

	@media (min-width: 320px) and (max-width: 480px) {
		flex-direction: column-reverse;

		&__checkout {
			display: flex;
			flex-direction: row-reverse;
			align-items: center;
			justify-content: space-around;
		}
	}
}

.checkout-price::v-deep  {
	@media (min-width: 320px) and (max-width: 480px) {
		.holiday-alarm-reminder {
			display: none;
		}

		.holiday-savings-msg {
			text-align: center !important;
			border-bottom: 1px solid #767676;
			width: 310 !important;
			margin: auto;
			margin-bottom: 5px;
			padding-bottom: 20px !important;
		}
	}

	.holiday-savings-msg {
		font-family: 'Akkurat-Normal';
		padding: 5px;
		padding-right: 0;
		margin-bottom: 10px;
		color: #fff;
		width: 342px;
		text-align: right;

		p {
			color: #B64CBD !important;
		}
	}


	.checkout-price__button {
		margin-right: 0px;
	}

	.checkout-price__bell {
		display: flex;

		.checkout-price__button {
			margin-right: 10px;
		}
	}
}

.suspended {
	opacity: 0.7;
	color: #FFFFFF;
	font-size: 14px;
	font-family: akkurat-light;
	letter-spacing: 0;
	line-height: 17px;
	text-align: right;

	@media (min-width: 992px) {
		margin-top: -13px;
		margin-bottom: 15px;
	}

	@media (min-width: 320px) and (max-width: 480px) {
		position: absolute;
		left: 50px;
		bottom: 4px;
	}

	@media (min-width: 375px) and (max-width: 812px) {
		left: 58px;
	}

	@media (min-width: 390px) and (max-width: 667px) {
		left: 78px;
	}
}

</style>


<style lang="scss">

.checkout-price-bottom {
	.checkout-price {
		.checkout__item:last-child {
			margin-right: 0 !important;
		}
	}
}
</style>
